import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import classes from "./Authorization.module.css";
import { AuthParams } from "../../types/common";
import { authToken } from "../../api/mainAPI";
import { Box, Button, Paper, TextField } from "@mui/material";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import CustomSnackbar from "../../components/UI/CustomSnackbar";
import { useNotification } from "../../hooks/useNotification";
import CustomPasswordInput from "../../components/UI/CustomPasswordInput";

const Authorization = () => {
    const [isAuth, setIsAuth] = useState({
        token: "",
    });
    const { setNotification, setOpenSnackbar, notification, openSnackbar } = useNotification();
    const [load, setLoad] = useState(false);

    const { control, setError, handleSubmit } = useForm<any>();
    const formHandler: SubmitHandler<AuthParams> = data => {
        setLoad(true);
        authToken(
            data,
            ({ data }) => {
                setIsAuth({ ...data });
                localStorage.setItem("token", data.token);
                setLoad(false);
            },
            (err: any) => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setLoad(false);
                setOpenSnackbar(true);
                Object.keys(err?.errors).forEach((fieldName: any) => {
                    setError(fieldName, {
                        type: "custom",
                        message: err?.errors[fieldName],
                    });
                });
            },
        );
        setLoad(false);
    };

    return (
        <div className={classes.authorization}>
            <Paper
                sx={{
                    width: "50%",
                    padding: "20px",
                }}>
                <>
                    <Box
                        component="form"
                        sx={{
                            "& .MuiTextField-root": { my: 1 },
                        }}
                        noValidate
                        autoComplete="off">
                        <Controller
                            defaultValue={""}
                            name="email"
                            control={control}
                            rules={{
                                required: true,
                                maxLength: {
                                    value: 120,
                                    message: "Максимальная длина 120 символов",
                                },
                            }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size={"small"}
                                    fullWidth
                                    type="email"
                                    label={"email"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                        <Controller
                            defaultValue={""}
                            name="password"
                            control={control}
                            rules={{
                                required: true,
                                maxLength: {
                                    value: 120,
                                    message: "Максимальная длина 120 символов",
                                },
                            }}
                            render={({ field, fieldState }) => (
                                <CustomPasswordInput
                                    {...field}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size={"small"}
                                    fullWidth
                                    label={"Пароль"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                        {/*<Link to={"/forgot_password"}>Забыли пароль?</Link>*/}
                        <Button variant="outlined" fullWidth onClick={handleSubmit(formHandler)}>
                            Войти
                        </Button>
                    </Box>
                    {/*<span className={classes.authorization__nonAuth}>*/}
                    {/*    Еще нет аккаунта? <Link to={"/registration"}>Регистрация</Link>*/}
                    {/*</span>*/}
                </>
            </Paper>
            <CustomSnackbar openSnackbar={openSnackbar} setOpenSnackbar={setOpenSnackbar} notification={notification} />
            <Loader backDrop open={load} />
            {isAuth.token && <Navigate to={`/personal`} />}
        </div>
    );
};

export default Authorization;
